import {init, send} from "@emailjs/browser";

export const sendEmail = (sendEmailParams) => {
    const EMAILJS_USER_ID = process.env.REACT_APP_EMAILJS_USER_ID;
    const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;


    if (EMAILJS_USER_ID && EMAILJS_SERVICE_ID && EMAILJS_TEMPLATE_ID) {
        // emailjsを初期化
        init(EMAILJS_USER_ID);

        // 送信するデータを定義
        const params = { ...sendEmailParams };

        // emailjsを送信
        send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, params, EMAILJS_USER_ID)
        // .then((response) =>  {
        //     console.log('SUCCESS!', response.status, response.text);
        // }, (error) =>  {
        //     console.log('FAILED...', error);
        // });
    }

}